import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { CompanyListFilter, User } from "@/graphql/codegen/graphql"

interface ManagerChipsProps {
  managerIds: string[] | undefined
  // The people the ids are looked up in.
  managerOptions: User[]
  onRemove: (key: keyof CompanyListFilter, value: string) => void
}

export const ManagerChips: React.FC<ManagerChipsProps> = ({ managerIds, managerOptions, onRemove }) => {
  // Each chip keeps its own id, so removing one never removes a neighbour when another id has no name loaded yet.
  const selectedManagers = useMemo(
    () =>
      (managerIds ?? []).flatMap((id) => {
        const name = managerOptions.find((manager) => manager.userId === id)?.name
        return name ? [{ id, name }] : []
      }),
    [managerIds, managerOptions]
  )

  return useMemo(
    () =>
      selectedManagers.map(({ id, name }) => (
        <FilterChip key={id} label={`Manager: ${name}`} onDelete={() => onRemove("managers", id)} />
      )),
    [selectedManagers, onRemove]
  )
}
